import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../hooks/useTheme';

/**
 * What a theme switch says and shows: the mode a click switches to. Shared with
 * the Theme row of the sidebar's user menu so the two switches stay identical.
 */
export const themeToggleLabel = (darkMode) =>
  darkMode ? 'Switch to light mode' : 'Switch to dark mode';

export const ThemeToggleIcon = ({ darkMode }) =>
  darkMode ? <Sun className="h-4 w-4" aria-hidden="true" /> : <Moon className="h-4 w-4" aria-hidden="true" />;

/**
 * Light/dark switch for the screens that have no sidebar (sign in, sign up,
 * organisation selection). Sits in the top right of the page; the parent must
 * be `relative` or the page itself.
 */
const ThemeToggle = () => {
  const { darkMode, setDarkMode } = useTheme();
  const label = themeToggleLabel(darkMode);
  return (
    <div className="absolute top-4 right-4">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setDarkMode(!darkMode)}
        aria-label={label}
        title={label}
      >
        <ThemeToggleIcon darkMode={darkMode} />
      </Button>
    </div>
  );
};

export default ThemeToggle;
